import { LinearProgress } from '@quillbot/design-system';

import withStyles from '@mui/styles/withStyles';
import createStyles from '@mui/styles/createStyles';

export default withStyles(() =>
  createStyles({
    root: {
      height: 2,
    },
    colorPrimary: {
      backgroundColor: 'white',
    },
  })
)(LinearProgress);
